
"use strict";

import numberFormat from "../common/number-format";
import leadingZeroes from "../common/lead-zeroes";

const SVOD_TABLE = "2";

export default function renderViewingSummaryReportCSV(data, options) {
    if (!data.length) {
        return 'No data for this week yet'
    }

    const decimals = (parseInt(options.dataType) === 0) ? 0 : 2;
    let pattern = "";

    const formatter = row => {
        const nullValueSymbol = (row.station_id === "Reporting Universe" || row.station_id === "Total TV") ? "" : "-";
        const minSec = `${row.avg_min}:${leadingZeroes(row.avg_sec)}`

        pattern = `"${(row.monthly_reach_000) ? row.monthly_reach_000 : nullValueSymbol}",` +
            `"${Number(row.monthly_reach_percentage) >= 0 ? numberFormat(row.monthly_reach_percentage, decimals) : nullValueSymbol}",` +
            `"${Number(row.total_identified_viewing) >= 0 ? numberFormat(row.total_identified_viewing, 2) : nullValueSymbol}",` +
            `="${Number(row.avg_min) >= 0 && Number(row.avg_sec) >= 0 ? minSec : nullValueSymbol}"`; // "=" character fix render problem on Excel

        return `"${row.station_name}",` + pattern
    };

    const standardRows = data.filter(row => row.table !== SVOD_TABLE)
        .map(formatter)
        .join("\n");

    const SVODRows = data.filter(row => row.table === SVOD_TABLE)
        .map(formatter)
        .join("\n");

    return `"",` +
        `"Total Identified Viewing",` +
        `"", , , ` +
        "\r\n" +
        `"",` +
        `"Universe: UK TV & Broadband Households",` +
        "\r\n" +
        `,` +
        `"Monthly Reach",` +
        `"",` +
        `"Share of Total Identified Viewing",` +
        `"Average Daily Minutes",` +
        "\r\n" +
        `"   ",` +
        `"000s",` +
        `"%",` +
        `"%",` +
        `"MM:SS",` +
        `\r\n${standardRows}` +
        "\r\n" +
        "\r\n" +
        `,` +
        `"Monthly Reach",` +
        `"",` +
        `"Share of Total Identified Viewing",` +
        `"Average Daily Minutes",` +
        "\r\n" +
        `"   ",` +
        `"000s",` +
        `"%",` +
        `"%",` +
        `"MM:SS",` +
        `\r\n${SVODRows}`;
};
